import React, { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { useSocket } from '../contexts/SocketContext';
import { useToast } from './Toast';
import { saveImageToAlbum } from '../utils/saveImage';
import { Image, Download } from 'lucide-react';

// 获客素材 · 证券侧：4 张步骤图，对应获客的 4 个步骤，用户可逐张保存后发给客户。
export const PUZZLE_MATERIAL_SLOTS = [1, 2, 3, 4];
// 标题后面附的时间提示：只有第 4 步带（15 分钟），其余步骤不带
const STEP_TIME = { 4: '(15分钟)' };

export default function PuzzleMaterialView() {
  const { subscribe } = useSocket();
  const { showToast } = useToast();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingNo, setSavingNo] = useState(null);

  const fetchAll = useCallback(() => {
    api.get('/puzzle/materials').then(r => setImages(r.data.images || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);
  useEffect(() => { fetchAll(); }, [fetchAll]);
  useEffect(() => {
    if (!subscribe) return;
    return subscribe((event) => { if (event === 'puzzle_materials_updated') fetchAll(); });
  }, [subscribe, fetchAll]);

  const handleSave = async (img) => {
    setSavingNo(img.slot_no);
    try {
      await saveImageToAlbum(img.image_data, `pintu-step${img.slot_no}.png`);
      showToast('已打开保存面板', 'success');
    } catch {
      showToast('保存失败，请长按图片保存', 'error');
    } finally { setSavingNo(null); }
  };

  if (loading) return <p style={{ textAlign: 'center', padding: 40, color: 'var(--c-text-secondary)' }}>加载中...</p>;

  const byNo = Object.fromEntries(images.map(i => [i.slot_no, i]));
  return (
    <>
      <div style={{ fontSize: 12, color: 'var(--c-text-secondary)', lineHeight: 1.6, margin: '0 2px 10px' }}>
        证券业务共 4 张素材图，对应获客的 4 个步骤，逐张保存后按顺序使用。
      </div>
      {PUZZLE_MATERIAL_SLOTS.map(no => {
        const img = byNo[no];
        return (
          <div key={no} className="card" style={{ textAlign: 'center', padding: 20, marginBottom: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
              <span style={{
                width: 22, height: 22, borderRadius: '50%', background: 'var(--c-primary)', color: '#fff',
                fontSize: 12, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>{no}</span>
              <span style={{ fontSize: 15, fontWeight: 700 }}>第 {no} 步{STEP_TIME[no] || ''}</span>
            </div>
            {img ? (
              <>
                <img src={img.image_data} alt={`步骤图${no}`}
                  style={{ display: 'block', margin: '0 auto', maxWidth: '100%', maxHeight: 320, borderRadius: 12 }}
                  onError={e => { e.target.style.display = 'none'; }} />
                <button className="btn btn-primary" onClick={() => handleSave(img)} disabled={savingNo === no}
                  style={{ marginTop: 14, height: 46, fontSize: 15 }}>
                  <Download size={16} /> {savingNo === no ? '保存中...' : `保存第 ${no} 步图`}
                </button>
              </>
            ) : (
              <div style={{ padding: '20px 0', color: 'var(--c-text-secondary)' }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}><Image size={36} color="var(--c-text-secondary)" strokeWidth={1.2} /></div>
                <p style={{ fontSize: 13 }}>管理员尚未设置第 {no} 步素材图</p>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}
